import { render, staticRenderFns } from "./ProductosDialogVenta.vue?vue&type=template&id=6e0e1644"
import script from "./ProductosDialogVenta.vue?vue&type=script&lang=js"
export * from "./ProductosDialogVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports